// PriceRule's fields are almost entirely FK/enum references and numeric bounds, not free text --
// these labels exist so create/update error messages stay consistent if a referenced entity's
// user-facing name ever changes. priority mirrors the DB's SmallInt column bounds
// (schema.prisma's PriceRule.priority @db.SmallInt); amount mirrors AssocPrice's own upper bound
// (ASSOC_PRICE_CONSTRAINTS.price in ../assoc-price/constraints.ts) since both guard a
// Decimal(28,9) money column at the GraphQL edge.
export const PRICE_RULE_CONSTRAINTS = {
    brandId: { label: 'Brand' },
    productTreeId: { label: 'Category' },
    stateId: { label: 'State' },
    brandMarketConfigId: { label: 'Market configuration' },
    customerId: { label: 'Customer' },
    productId: { label: 'Product' },
    scopeTypeId: { label: 'Scope type' },
    priority: { label: 'Priority', min: 0, max: 32_767 },
    pricingModeId: { label: 'Pricing mode' },
    paymentTermsId: { label: 'Payment terms' },
    amountTypeId: { label: 'Amount type' },
    amount: { label: 'Amount', max: 1_000_000_000 },
    derivationValue: { label: 'Adjustment', max: 1_000_000_000 },
    note: { label: 'Note', maxLength: 2000 },
};
/** Shared between `setPriceInputSchema`'s own `superRefine` (checking a start/end pair present in
 *  the same request body) and `reactivatePriceRule`'s resolver guard (checking a value resolved
 *  from stored state, for the case where the request supplies only `effectiveEnd`) -- both compare
 *  the same `effectiveEnd <= effectiveStart` invariant against different value sources, so the
 *  message stays a single source of truth instead of two copies that can drift apart. */
export const INVERTED_WINDOW_MESSAGE = 'End date must be after start date.';
//# sourceMappingURL=constraints.js.map